module.exports = __webpack_public_path__ + "static/media/dark.62759afd.png";